
export const About = () => {
    return (
        <>
            <div className="flex justify-center item-center flex-col pb-0 lg:pb-4 mb-4 lg:my-6  lg:h-[14rem] lg:px-16 px-6">
                <p className="text-3xl font-bold mb-4 lg:mx-10 sm:mx-2 tracking-wide"><span className="underline underline-offset-8 decoration-4 decoration-[#E30022]">Abo</span>ut the conference</p>
                <p className=" text-md lg:text-lg font-[300] lg:mx-10 sm:mx-2">
                Sustainable development is essential to address the challenges of climate
change, economic inequality, and social injustices. The Sustainable
Development Goals (SDGs) set by the United Nations provide a universal
blueprint to achieve a better and more sustainable future for all. To foster
academic discussion, innovation, and actionable solutions, IILM University,
Greater Noida, proposes to host a National Conference on Sustainable
Development Goals on 25 February 2025. This conference aims to bring
together research scholars, academicians, policymakers, industry leaders, and
students to share insights, research findings, and strategies that contribute
towards achieving the SDGs.
                </p>
            </div>
        </>
    );
}